import ProfileTopNavigation from './ProfileTopNavigation';
import ReferralSection from '../../PageComponent/ProfilePage/ReferralSection';

function Referral() {
  return (
    <div className="text-coalBlack">
      <ProfileTopNavigation pageTitle={'Invite a Friend'} />
      <ReferralSection />
    </div>
  );
}

export default Referral;
